import React, { useEffect, useState } from "react";
import axios from "axios";
import "../assets/styles/main.css";
import { Input, Select, Modal } from "antd"; // Import Modal for confirmation
import toast, { Toaster } from "react-hot-toast";
import { BASE_URL } from "../constants/Constants";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { Option } = Select;
const { confirm } = Modal;

const PaymentChange = () => {
  const userId = localStorage.getItem("userId");
  const [formData, setFormData] = useState({
    paymentGatewayName: "Razorpay", // Default to Razorpay to make it easier
    keyName: "",
    secretKey: "",
  });
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  const notify = (value) => toast(`${value} is Selected`);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${BASE_URL}/api/v1/paymentmethod/paymentconfig`,
        formData
      );
      setFormData({ paymentGatewayName: "Razorpay", keyName: "", secretKey: "" });
      fetchPaymentOptions();
      toast.success("Payment Method Updated!");
    } catch (error) {
      console.error("Error:", error.message);
      toast.error("Failed to add payment method");
    }
  };

  // --- NEW: DELETE HANDLER ---
  const showDeleteConfirm = () => {
    confirm({
      title: 'Are you sure you want to delete these credentials?',
      icon: <ExclamationCircleOutlined />,
      content: `This will remove ${formData.paymentGatewayName} keys. Payments will stop working.`,
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        handleDelete();
      },
    });
  };

  const handleDelete = async () => {
    try {
      await axios.delete(`${BASE_URL}/api/v1/paymentmethod/deleteconfig`, {
        params: { gatewayName: formData.paymentGatewayName }
      });
      toast.success("Credentials Deleted Successfully");
      setFormData({ paymentGatewayName: "Razorpay", keyName: "", secretKey: "" });
    } catch (error) {
      toast.error("Failed to delete. Check if name matches.");
    }
  };
  // ---------------------------

  const handleOptionSubmit = async (value) => {
    try {
      await axios.post(
        `${BASE_URL}/api/v1/paymentmethod/updatestatus`,
        { paymentGatewayName: value }
      );
      notify(value);
    } catch (error) {
      console.error("Error:", error.message);
      toast.error("Failed to update status");
    }
  };

  const fetchPaymentOptions = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/paymentmethod/paymentoptions`
      );
      setPaymentOptions(response.data.paymentGatewayNames || []);
    } catch (error) {
      console.error("Error fetching payment options:", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPaymentOptions();
  }, []);

  return userId ? (
    <div>
      <form onSubmit={handleSubmit}>
        <label className="block mb-2 text-sm font-medium ">
          Payment Gateway Name:
          <Input
            type="text"
            name="paymentGatewayName"
            placeholder="Razorpay"
            value={formData.paymentGatewayName}
            onChange={handleChange}
          />
        </label>

        <label className="block mb-2 text-sm font-medium ">
          Key Name:
          <Input
            type="text"
            name="keyName"
            placeholder="Enter your Key name"
            value={formData.keyName}
            onChange={handleChange}
          />
        </label>

        <label className="block mb-2 text-sm font-medium ">
          Secret Key:
          <Input
            type="text"
            name="secretKey"
            placeholder="Enter your Secret Key"
            value={formData.secretKey}
            onChange={handleChange}
          />
        </label>

        <div className="flex gap-4 mt-4">
            <button
            className="rounded-md p-2 bg-blue-500 text-white text-base hover:bg-blue-600"
            type="submit"
            >
            Save / Update
            </button>

            {/* DELETE BUTTON */}
            <button
            className="rounded-md p-2 bg-red-500 text-white text-base hover:bg-red-600"
            type="button"
            onClick={showDeleteConfirm}
            >
            Delete Config
            </button>
        </div>

      </form>
      <div className="mt-5">
        <h2 className="">Payment Options:</h2>
        <Select
          defaultValue="Select Payment Method"
          style={{ width: 220 }}
          onChange={handleOptionSubmit}
        >
          {loading ? (
            <Option disabled>Loading...</Option>
          ) : (
            paymentOptions.map((paymentGatewayName, idx) => (
              <Option key={idx} value={paymentGatewayName}>
                {paymentGatewayName}
              </Option>
            ))
          )}
        </Select>
      </div>
      <Toaster
        toastOptions={{
          style: {
            border: "1px solid green",
            padding: "16px",
            background: "white",
          },
        }}
      />
    </div>
  ) : (
    <span
      style={{
        fontSize: "20px",
        background: "white",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      Sign in to see payments
    </span>
  );
};

export default PaymentChange;